import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { IndicationsService } from 'src/app/services/indications.service';

export const allowRescheduleResolver: ResolveFn<{ allow: boolean; remaining: number }> = (
  route: ActivatedRouteSnapshot
) => {
  const tenantService = inject(IndicationsService);

  const id =
    route.paramMap.get('id') ?? route.parent?.paramMap.get('id');

  if (!id || id === 'novo') {
    return { allow: true, remaining: 0 };
  }

  return tenantService.allowReschedule(Number(id));
};
